module.exports = __webpack_public_path__ + "static/wingo-ec66c6db18940f19505533a0ba98dee7.png";